<template>
  <div class="body-card">
    <div class="carousel-facility-container">
      <vue-slick-carousel
        class=""
        v-if="image?.length > 0"
        v-bind="slickOptions"
      >
        <div v-for="(item, index) in image" :key="index">
          <img
            @error="handleImageError()"
            class="image"
            :src="item"
            :alt="item"
          />
        </div>
      </vue-slick-carousel>
      <!-- <el-carousel
        class="carousel-review-facility"
        height="152px"
        :autoplay="false"
        :interval="5000"
        arrow="never"
        v-if="image?.length > 0"
      >
        <el-carousel-item v-for="(item, index) in image" :key="index">
          <img
            @error="handleImageError()"
            class="image"
            :src="item"
            :alt="item"
          />
        </el-carousel-item>
      </el-carousel> -->
    </div>
    <div @click="routePush" class="content" style="cursor: pointer">
      <p class="facility-name m-0  fw-600 c-caption">{{ title }}</p>
      <div
        style="margin-top: 5px !important; height:30px"
        class="d-flex align-items-start  m-0"
      >
        <img style="width:15px" class="mr-10" :src="bg.icon_address1" alt="" />
        <p class="c-tiny des-facility mt-3 m-0">
          {{ location }}
        </p>
      </div>

      <div class="flex align-items-start justify-content-between">
        <p class="c-tiny m-0 c-medium-text">{{ holes_amount }} holes</p>
        <div class="">
          <img
            v-for="(item, index) in [1, 2, 3, 4, 5]"
            :key="index"
            class="ml-1"
            :src="item > rating ? iconStart : iconStart1"
            alt="icon start"
          />
          <span style="color: #333333; font-weight:200" class="ml-5 c-tiny"
            >({{ reviews_count }} reviews)</span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatCurrency, convertDate, formatNumber } from "@/utils/formatData";
import { getBackGround } from "../../../utils/wapAuth";
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import "vue-slick-carousel/dist/vue-slick-carousel.css";

export default {
  bodyClass: "card-facilities",
  components: {
    VueSlickCarousel
  },
  props: {
    objectData: {
      type: Object,
      default() {
        return {};
      }
    },
    title: {
      default: ""
    },
    location: {
      default: ""
    },
    holes_amount: {
      default: ""
    },
    reviews_count: {
      default: ""
    },
    image: {
      type: Array,
      default: () => {
        return [
          "https://web-api.vcallid.com/static/uploads/03126e45-475d-4882-a01f-7a3cfaf90f3f.png",
          "https://web-api.vcallid.com/static/uploads/03126e45-475d-4882-a01f-7a3cfaf90f3f.png",
          "https://web-api.vcallid.com/static/uploads/03126e45-475d-4882-a01f-7a3cfaf90f3f.png",
          "https://web-api.vcallid.com/static/uploads/03126e45-475d-4882-a01f-7a3cfaf90f3f.png"
        ];
      }
    },
    id: {
      default: ""
    },
    priceDiscount: {
      default: ""
    },
    rating: {
      default: 4
    }
  },
  watch: {
    objectData(val) {}
  },
  data() {
    return {
      bg: getBackGround(),
      type: null,
      iconStart1: require("@/assets/img/v3/icon/icon_star_1.svg"),
      iconStart: require("@/assets/img/v3/icon/icon_star.svg"),
      icons: {},
      slickOptions: {
        dotsClass: "slick-dots dots-card-facility-class",
        dots: true,
        arrows: false,
        autoplaySpeed: 2000,
        autoplay: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 900,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              autoplay: false
            }
          }
        ]
      }
    };
  },
  computed: {},
  methods: {
    formatCurrency,
    convertDate,
    formatNumber,
    routePush() {
      return this.$router.push(`/san/chi-tiet/${this.id}`);
    },
    handleImageError() {
      return "https://web-api.vcallid.com/static/uploads/03126e45-475d-4882-a01f-7a3cfaf90f3f.png";
    }
  }
};
</script>
<style lang="scss">
.carousel-review-facility {
  .el-carousel__button {
    width: 5px;
    height: 5px;
    border-radius: 100%;
    background: #00000033;
    opacity: 1 !important;
  }
  .el-carousel__indicator.is-active button {
    opacity: 1;
    background: v-bind("bg.c_inherit_text") !important;
  }
  .el-carousel__indicator--horizontal {
    padding: 5px 4px;
  }
}

.carousel-facility-container {
  .slick-slide {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
}
.dots-card-facility-class {
  bottom: 15px !important;
  li {
    position: relative;
    display: inline-block;
    width: 15px;
    height: 15px;
    margin: 0;
    /* margin: 0 5px; */
    padding: 0;
    cursor: pointer;
  }
  li button:before {
    font-size: 7px;
    color: #e6e4e4;
    opacity: 1;
  }
  .slick-active button:before {
    color: v-bind("bg.c_inherit_text") !important;
    opacity: 1;
    font-size: 8px;
  }
}
</style>

<style scoped lang="scss">
.mr-10 {
  margin-right: 10px;
}

.content {
  padding: 12px;
}

.full-width {
  width: 100%;
}

.facility-title {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.icon-sale-container {
  position: absolute;
  top: 10px;
}

.image-container {
  position: relative;
  overflow: hidden;
  height: 152px;
}
.body-card {
  background-color: #ffff;
  position: relative;
  overflow: hidden;
  border-radius: 8px;
  margin-bottom: 10px;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.15);
}
.body-card:hover {
  transition: 2ms;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px,
    rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
}
.image {
  user-drag: none; /* Safari */
  -webkit-user-drag: none; /* Chrome, Safari, Edge */
  -moz-user-select: none; /* Firefox */
  user-select: none; /* Ngăn chọn ảnh */
  pointer-events: auto; /* Vẫn cho click */
  width: 100% !important;
  height: 152px !important;
  border-radius: 8px;

  object-fit: cover;
  object-position: top;
}
.text-left {
  width: 100%;
  text-align: left;
}

.mb-0 {
  margin-bottom: 0;
}
.facility-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0;
}
.des-facility {
  display: -webkit-box;
  -webkit-line-clamp: 2; /* Số dòng giới hạn */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0;
  line-height: 15px;
}
@media screen and (min-width: 0px) and (max-width: 480px) {
  .body-card {
    position: relative;
    overflow: hidden;
    border-radius: 6px;
    margin-bottom: 10px;
    width: 238px;
    box-shadow: 0px 0px 4px 0px #00000026;
  }
}
</style>
